// Shared color tokens for Navigator Reports
export const PRIMARY_BLUE = '#005CBC';
export const WARNING_RED = '#C12C01';
export const POS_GREEN = '#0A8A1F';
export const AMBER = '#F59E0B';
export const MUTED_GRAY = '#9CA3AF';

// Neutral tokens (borders / text)
export const BORDER_GRAY = '#E4E7EC'; // card borders and section dividers
export const TEXT_MUTED = '#667085';  // secondary / label text
export const TEXT_STRONG = '#101828'; // emphasised value text

// Thresholds
export const THRESHOLDS = {
  trendWarningPct: 10, // trend points below this render as warning red
  barTargetPct: 100,   // bar charts target (100% means below target when <100)
};
